import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Railway Docker build can miss VITE_* vars at build-time.
// Keep a safe fallback for public Firebase web config to avoid blank screen.
const fallbackFirebaseConfig = {
  apiKey: "AIzaSyBq6fGreH4LwuvQS1XW8gyyZ6PrfKWLw5k",
  authDomain: "www.hrcrm.asia",
  projectId: "recruit-crm-2026",
  storageBucket: "recruit-crm-2026.firebasestorage.app",
  messagingSenderId: "582060157621",
  appId: "1:582060157621:web:4963694ddaf99a7ebeecfc",
};

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || fallbackFirebaseConfig.apiKey,
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || fallbackFirebaseConfig.authDomain,
  projectId:
    import.meta.env.VITE_FIREBASE_PROJECT_ID || fallbackFirebaseConfig.projectId,
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    fallbackFirebaseConfig.storageBucket,
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ||
    fallbackFirebaseConfig.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || fallbackFirebaseConfig.appId,
};

// Диагностика: проверяем что конфиг реально попал в бандл
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "undefined") {
  console.error(
    "❌ Firebase config empty — VITE_FIREBASE_* не попали в билд.\n" +
    "   → Проверь ARG директивы в Dockerfile\n" +
    "   → Проверь VITE_FIREBASE_* в Railway variables\n" +
    "   → Используется fallback: " + (fallbackFirebaseConfig.apiKey ? "да" : "НЕТ")
  );
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Диагностика auth ошибок
auth.onAuthStateChanged(() => {}, (error) => {
  console.error(
    "❌ Firebase Auth ошибка: " + error.message + "\n" +
    "   → Проверь authDomain в конфиге: " + firebaseConfig.authDomain + "\n" +
    "   → Проверь что домен в Firebase Console → Authorized domains\n" +
    "   → Проверь navigateFallbackDenylist в vite.config.ts (SW не должен перехватывать /__/)"
  );
});
